import { Outlet, useNavigate } from "react-router-dom";
import { AccountHeader } from "../AccountBankingService";
import { styled } from "styled-components";
import { DashboardGoBackButton } from "../../components/Untils/DashboardGoBackButton";
import Layout from "../../components/Accounts/Layout";
import Stepper, { StepData } from "../../components/CompleteAccount/Stepper";
import { returnStepperData } from "../../utils/returnStepperData";
import { RootState } from "../../store/rootReducer";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../store";
import { useEffect } from "react";
import { fetchOnboardingData } from "../../store/onBoarding/onBoardingSlice";
import { LoadingSpinner, Overlay } from "../AddUserPage/AddUser";

export interface CompleteAccountSetUp {
  id: string;
  organizationId: string;
  stepperData: StepData[];
  meta?: string;
  createdAt: Date;
  updatedAt: Date;
}
const CompleteAccountSetupPage = () => {
  const dispatch = useAppDispatch();
  const { onBoardingData, loading } = useSelector(
    (state: RootState) => state.OnBoarding
  );

  const modifiedStepperData = returnStepperData(onBoardingData);

  useEffect(() => {
    dispatch(fetchOnboardingData());
  }, [dispatch]);

  return (
    <CompleteAccountWrapper>
      {loading && (
        <Overlay>
          <LoadingSpinner />
        </Overlay>
      )}
      <DashboardGoBackButton />
      <AccountHeader>Complete Account Set Up</AccountHeader>
      <LayoutWrapper>
        <Layout width="22%" height="fit-content">
          <Stepper steps={modifiedStepperData} />
        </Layout>
        <Layout width="76%" noPadding>
          <Outlet />
        </Layout>
      </LayoutWrapper>
    </CompleteAccountWrapper>
  );
};

export default CompleteAccountSetupPage;

export const CompleteAccountWrapper = styled.div`
  width: 78vw;
  padding: 1rem;
  @media only screen and (max-width: 768px) {
    padding: 0.5rem;
    width: 100vw;
  }
`;
export const LayoutWrapper = styled.div<{ css?: string }>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    justify-content: flex-start;
    gap: 1rem;
  }
`;
